<template>
  <div>
    <my-head></my-head>
    <img src="../../assets/Rectangle353.png" style="width: 100%" />
    <div class="capitaloperation minH">
      <div class="capital_title">服务科创板</div>

      <div class="capital_content">
        2018年11月5日，国家主席习近平在首届中国国际进口博览会开幕式上宣布设立科创板，是独立于现有主板市场的新设板块，并在该板块内进行注册制试点。<br />
        设立科创板并试点注册制是提升服务科技创新企业能力、增强市场包容性、强化市场功能的一项资本市场重大改革举措。是落实创新驱动和科技强国战略、推动高质量发展、支持上海国际金融中心和科技创新中心建设的重大改革举措，是完善资本市场基础制度、激发市场活力和保护投资者合法权益的重要安排。、<br /><br />
        2019年1月30日，中国证监会发布《关于在上海证券交易所设立科创板并试点注册制的实施意见》。《实施意见》强调，在上交所新设科创板，坚持面向世界科技前沿、面向经济主战场、面向国家重大需求，主要服务于符合国家战略、突破关键核心技术、市场认可度高的科技创新企业。重点支持新一代信息技术、高端装备、新材料、新能源、节能环保以及生物医药等高新技术产业和战略性新兴产业，推动互联网、大数据、云计算、人工智能和制造业深度融合，引领中高端消费，推动质量变革、效率变革、动力变革。<br />
        上海国际知识产权运营公共服务平台聚焦服务战略性新兴产业，服务并促进科技创新要素流动和价值实现，发展定位和科创板的定位完全吻合。中知路平台将为科创板企业提供知识产权有关全面服务，包括知识产权战略规划、技术规划、专利导航、价值评估、专利运营交易、IP并购、IP资本运作、IP质押融资等，助力科创板投资人和企业取得成功。
      </div>

      <img src="../../assets/capital_2.png" class="capital_img" alt="" />
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.capitaloperation {
  width: 80%;
  margin: 48px auto 100px;
  .capital_img {
    width: 100%;
    margin-bottom: 32px;
  }
  .capital_content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .capital_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
